module.exports = __webpack_public_path__ + "img/reward_bg.a3db10f3.png";